import { ref } from "vue";
import { getHooks } from './useHOC'

const useStateType = 1

export function useState<T>(params: T) {
  // const hooks = mounteds[mountedIndex][1] || [];
  // mounteds[mountedIndex][1] = hooks
  // const hookIndex = hookIndexList[mountedIndex][0] || 0;
  // const hook = hooks?.[hookIndex] || ref(params);
  // hooks[hookIndex] = hook
  // hookIndexList[mountedIndex][0] = hookIndexList[mountedIndex][0] + 1

  const [hooks, currentHookIndex] = getHooks(useStateType);
  const hook = hooks?.[currentHookIndex] || ref(params);
  hooks![currentHookIndex] = hook;
  // const forceUpdate: Ref<number> = mounteds[mountedIndex][0];
  const forceUpdate = ([] as typeof hooks).concat(getHooks(0)[0])[0];
  const ret: [T, (params: T | ((value: T) => T)) => void] = [
    hook.value,
    (params: T | ((value: T) => T)) => {
      hook.value = params instanceof Function ? params(hook.value) : params;
      (forceUpdate.value = +new Date());
    },
  ];
  return ret;
}